import React, { useState } from "react";
import { ActionMeta, components, OnChangeValue, SingleValue } from "react-select";
import { GroupBase, Props as SelectProps } from "react-select";
import { Option } from "types";
import * as Styled from "./TypeaheadSelect.styled";
interface GroupedOption extends GroupBase<Option> {}
interface TypeaheadSelectProps extends SelectProps<Option, false, GroupedOption> {
  isClearable?: boolean;
}
export const TypeaheadSelect: React.FC<TypeaheadSelectProps> = props => {
  const {
    isClearable = false
  } = props;
  const [inputValue, setInputValue] = useState("");
  const handleInputChange = (newValue: string) => {
    setInputValue(newValue);
  };
  const handleChange = (newValue: OnChangeValue<Option, false>, actionMeta: ActionMeta<Option>) => {
    const selectedOption = newValue as SingleValue<Option> | null;
    if (selectedOption?.value === "reset") {
      props.onChange?.(null as unknown as SingleValue<Option>, {
        action: "deselect-option",
        option: null as unknown as Option
      } as ActionMeta<Option>);
    } else if (actionMeta.action === "create-option") {
      props.onChange?.(selectedOption as unknown as SingleValue<Option>, {
        action: "select-option",
        option: selectedOption as unknown as Option
      } as ActionMeta<Option>);
    } else {
      props.onChange?.(selectedOption as unknown as SingleValue<Option>, actionMeta);
    }
  };
  const ClearIndicator = (clearProps: any) => <components.ClearIndicator {...clearProps} data-sentry-element="unknown" data-sentry-component="ClearIndicator" data-sentry-source-file="index.tsx">
            <div onClick={() => handleChange(null as unknown as SingleValue<Option>, {
      action: "deselect-option",
      option: null as unknown as Option
    } as ActionMeta<Option>)}>
                ✕
            </div>
        </components.ClearIndicator>;
  return <Styled.SelectWrapper data-sentry-element="unknown" data-sentry-component="TypeaheadSelect" data-sentry-source-file="index.tsx">
            <Styled.CreatableReactSelect {...props} inputValue={inputValue} onInputChange={handleInputChange}
    // @ts-ignore
    onChange={handleChange} options={props.options} components={{
      ClearIndicator
    }} placeholder="Type or select an option..." formatCreateLabel={inputValue => `Create "${inputValue}"`} isClearable={isClearable} menuPosition="fixed" data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
        </Styled.SelectWrapper>;
};